var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"message-convert-container",style:({
    height: _setup.calculateHeight > 0 ? `${_setup.calculateHeight}px` : 'auto',
    width: _setup.calculateWidth > 0 ? `${_setup.calculateWidth}px` : 'auto',
  })},[(_setup.convertFinished)?_c('div',{ref:"convertContentRef",class:{
      'convert-content': true,
      'occur': _setup.calculateHeight > 0,
    }},[_vm._v(" "+_vm._s(_setup.convertText)+" ")]):_vm._e(),_c('div',{ref:"convertLoadingRef",class:{
      'loading': true,
      'loading-end': _setup.convertFinished
    }},[_vm._v(" "+_vm._s(_setup.TUITranslateService.t('TUIChat.转换中'))+"... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }